import type { MetricStatus, Benchmark } from '../types'

export function getStatus(value: number, benchmark: Benchmark): MetricStatus {
  if (!Number.isFinite(value)) return 'danger'

  const [goodThreshold, okThreshold] = benchmark.thresholds

  if (benchmark.direction === 'lower-is-better') {
    if (value <= goodThreshold) return 'success'
    if (value <= okThreshold) return 'warning'
    return 'danger'
  }

  if (value >= goodThreshold) return 'success'
  if (value >= okThreshold) return 'warning'
  return 'danger'
}
